var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWearable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#84B5CB;}\r\n\t.st1{fill:#9FC9D3;}\r\n\t.st2{fill:#393F4A;}\r\n\t.st3{fill:#2C2F38;}\r\n\t.st4{fill:#FF5364;}\r\n\t.st5{fill:#DF4D60;}\r\n\t.st6{fill:#547580;}\r\n\t.st7{fill:#3F5C6C;}\r\n\t.st8{fill:#FFFFFF;}\r\n\t.st9{fill:#D1D4D1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_05---Heart-Rate-Monitor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M409.8,242.8h30.9c5.2,0.4,9.7-3.3,10.3-8.5v-34c-0.6-5.2-5.1-8.9-10.3-8.5h-32.1L409.8,242.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st1",
    d: "M451,200.3v17c-0.6-5.1-5.1-8.9-10.3-8.5H409l-0.4-17h32.2C445.9,191.4,450.4,195.2,451,200.3z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    className: "st2",
    d: "M417,208.8l0,84.9c0.1,41.8-20.3,80.9-54.7,104.7c-6,4.1-12.3,7.9-18.7,11.3H116.8 c-6.4-3.4-12.7-7.2-18.7-11.3c-34.3-23.8-54.8-62.9-54.7-104.7l0-84.9H417z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    className: "st3",
    d: "M417,208.8l0,84.9c0,32.2-12.1,63.2-34,86.8V208.8L417,208.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    className: "st3",
    d: "M77.4,208.8v171.7c-21.9-23.6-34-54.6-34-86.8l0-84.9H77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    className: "st4",
    d: "M132.9,71.1l24.9-56C160.5,9,166.6,5,173.3,5h113.8c6.7,0,12.8,4,15.5,10.1l24.9,56H132.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6_",
    className: "st5",
    d: "M230.2,5v66.1h-97.3l24.9-56C160.5,9,166.6,5,173.3,5H230.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "st6",
    cx: 230.2,
    cy: 208.8,
    rx: 186.8,
    ry: 161.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    className: "st4",
    d: "M114.1,389.8l12.2,93c1.1,8.5,8.3,14.8,16.8,14.8h174c8.5,0,15.7-6.3,16.8-14.8l12.2-93 c0.4-3.1-0.9-6.1-3.5-7.9c-2.5-1.8-5.8-2.1-8.6-0.8c-65.9,30.7-142.1,30.7-208,0c-2.8-1.3-6.1-1-8.6,0.8 C115.1,383.7,113.8,386.7,114.1,389.8L114.1,389.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8_",
    className: "st5",
    d: "M230.2,404.1v93.4h-87c-8.5,0-15.7-6.3-16.8-14.8l-12.2-93c-0.4-3.1,0.9-6.1,3.4-8 c2.5-1.8,5.9-2.1,8.6-0.7C158.7,396.4,194.3,404.2,230.2,404.1L230.2,404.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9_",
    className: "st7",
    d: "M370.9,314.9c-37.9,36.1-88.4,56-140.7,55.3c-103.2,0-186.8-72.3-186.8-161.3 S127,47.5,230.2,47.5c17.2,0,34.3,2,50.9,6.1c-8.6,2.8-17,5.9-25.3,9.4c-25.2,10.7-50.9,23.8-65.3,48.4c-11.5,20.9-14,45.6-7,68.4 c11.7,39.7,44.2,67.4,82.4,80.8c29.7,10.4,62.6,14.7,87.6,35.4C360.1,301.6,366,307.9,370.9,314.9L370.9,314.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10_",
    className: "st4",
    d: "M230.2,139c18.6-16.8,42.9-25.9,67.9-25.5c18.5,0.2,36.2,7.8,49,21.2 c12.8,13.4,19.6,31.4,19,49.9c0,38.1-28.7,103.8-135.9,132.8C123,288.3,94.4,222.7,94.4,184.5c-0.7-18.5,6.2-36.5,19-49.9 s30.5-21,49-21.2C187.3,113.1,211.6,122.2,230.2,139z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_",
    className: "st5",
    d: "M316.2,276.1c-25.5,19.5-54.7,33.6-85.9,41.2C123,288.4,94.4,222.6,94.4,184.5 c-0.7-18.5,6.2-36.5,19-49.8s30.5-21,49-21.2c8.6,0,17.2,1,25.6,3.1c-9.1,19.8-10.6,42.3-4.2,63.2c11.7,39.7,44.2,67.4,82.4,80.8 C282.4,266.5,299.7,270.3,316.2,276.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_",
    className: "st8",
    d: "M255.7,268.2c-3,0-5.7-1.6-7.3-4.1l-43.7-72.8l-18.2,30.3c-1.5,2.6-4.3,4.1-7.3,4.1H85.9 c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5h88.6l23-38.3c1.6-2.4,4.4-3.8,7.3-3.8c2.9,0,5.6,1.4,7.3,3.8l43.7,72.8l18.2-30.3 c1.5-2.6,4.3-4.1,7.3-4.1h93.4c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5H286l-23,38.3C261.4,266.7,258.7,268.2,255.7,268.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_13_",
    className: "st9",
    d: "M195.6,206.6l-9,15c-1.5,2.6-4.3,4.2-7.3,4.2H85.9c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5 h88.6l12.2-20.3C189,194.8,192,200.9,195.6,206.6L195.6,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_14_",
    className: "st9",
    d: "M265.2,260.4l-2.2,3.7c-1.5,2.6-4.3,4.2-7.3,4.2s-5.8-1.6-7.3-4.2l-9.6-16 C247.2,253,256,257.2,265.2,260.4L265.2,260.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWearable);
export default __webpack_public_path__ + "static/media/wearable.b96534ce94c9416de3f87a66fdbeb98f.svg";
export { ForwardRef as ReactComponent };